// functions/LegsManager.js

import { calculatePriceLegs } from "./calculatePrice";

export class LegsManager {
  constructor(
    activeProduct,
    setActiveProduct,
    basePrice,
    setLegPrice,
    setState,
    state
  ) {
    this.activeProduct = activeProduct;
    this.setActiveProduct = setActiveProduct;
    this.basePrice = basePrice;
    this.setLegPrice = setLegPrice;
    this.setState = setState;
    this.state = state;
  }

  resetDownstream(step) {
    const newState = { completedLegs: false };
    if (step === "boardMaterial") {
      newState.activeItem = null;
      newState.boardWeight = null;
      newState.legMaterial = null;
      newState.legColor = null;
      newState.legColorCategory = null;
      newState.legModel = null;
      newState.isIncreased = false;
    }
    if (step == "boardWeight") {
      newState.legMaterial = null;
      newState.legColor = null;
      newState.legColorCategory = null;
      newState.legModel = null;
      newState.isIncreased = false;
    }
    if (step === "material") {
      newState.legModel = null;
      newState.legColor = null;
      newState.legColorCategory = null;
      newState.isIncreased = false;
      this.setLegPrice(0);
    }

    if (step === "color") {
      newState.legModel = null;
      newState.legColorCategory = null;
      newState.isIncreased = false;
    }

    if (step === "colorCategory") {
      newState.legModel = null;
      newState.isIncreased = false;
    }

    if (step === "model") {
      newState.completedLegs = true;
    }

    this.setState((prev) => ({ ...prev, ...newState }));
  }
  selectBoardMaterial(boardMaterial) {
    this.resetDownstream("boardMaterial");
    this.setState((prev) => ({
      ...prev,
      completedBoard: false,
      completedLegMaterials: false,
      completedModels: false,
      boardMaterial: boardMaterial,
    }));
    this.setActiveProduct((prev) => ({
      ...prev,
      board: {
        Materijal: boardMaterial.name,
      },
      legs: {},
    }));
  }
  selectBoardWeight(boardWeight) {
    this.resetDownstream("boardWeight");
    this.setState((prev) => ({
      ...prev,
      completedBoard: false,
      completedLegMaterials: false,
      completedModels: false,
      boardWeight: boardWeight,
    }));
    this.setActiveProduct((prev) => ({
      ...prev,
      board: {
        Materijal: prev.board.Materijal,
        Debljina: boardWeight.name,
      },
      legs: {},
    }));
  }
  selectMaterial(material) {
    this.resetDownstream("material");

    this.setState((prev) => ({
      ...prev,
      completedLegMaterials: false,
      completedModels: false,
      legMaterial: material,
    }));
    this.setActiveProduct((prev) => ({
      ...prev,
      legs: {
        Materijal: material.name,
      },
    }));
  }

  selectColor(color) {
    this.resetDownstream("color");

    this.setState((prev) => ({
      ...prev,
      completedLegMaterials: false,
      completedModels: false,
      legColor: color,
    }));
    this.setActiveProduct((prev) => ({
      ...prev,
      legs: {
        Materijal: prev.legs.Materijal,
        Boja: color.name,
      },
    }));
  }

  selectColorCategory(color) {
    this.resetDownstream("colorCategory");

    this.setState((prev) => ({
      ...prev,
      completedLegMaterials: false,
      completedModels: false,
      legColorCategory: color,
    }));
    this.setActiveProduct((prev) => ({
      ...prev,
      legs: {
        ...prev.legs,
        "Rubio Boja": color.name,
      },
    }));
  }

  selectModel(model) {
    this.resetDownstream("model");

    this.setState((prev) => ({
      ...prev,
      completedModels: false,
      legModel: model,
    }));
    this.setActiveProduct((prev) => ({
      ...prev,
      legs: {
        ...prev.legs,
        Model: model.name,
      },
    }));

    const price = calculatePriceLegs(this.activeProduct, model, this.basePrice);
    this.setLegPrice(price);
  }
}
